import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  PieChart, Pie, Cell, Tooltip, Legend,
  BarChart, Bar, XAxis, YAxis, ResponsiveContainer
} from "recharts";
import { baseUrl, userName, ipAddress } from './Univ.js';

const COLORS = [
  "#0088FE", "#00C49F", "#FFBB28", "#FF8042",
  "#845EC2", "#D65DB1", "#FF6F91", "#4D96FF",
  "#2C73D2", "#008E9B", "#FFC75F", "#F9F871"
];

function LiveDashboard() {
  const [level, setLevel] = useState("district");
  const [selectedBooth, setSelectedBooth] = useState(null);
  const [pieData, setPieData] = useState([]);
  const [hourlyData, setHourlyData] = useState([]);
  const [navHistory, setNavHistory] = useState([]); // ✅ local history stack

  useEffect(() => {
    axios.get(baseUrl + "pie-district/")
      .then(res => setPieData(res.data));
  }, []);

  const onLegendClick = (item) => {
    axios.get(baseUrl + `constituency-pie/?district=${item.value}`)
      .then(res => {
        setNavHistory(prev => [...prev, level]); // push current level
        setLevel("constituency");
        setPieData(res.data);
      });
  };

  const onPieClick = (data) => {
    setSelectedBooth(data.name);
    axios.get(`${baseUrl}hourly-turnout/?booth_id=${data.id}`)
      .then(res => setHourlyData(res.data))
      .catch(err => console.error(err));
  };

const handleBack = () => {
  const prevHistory = [...navHistory];
  const lastLevel = prevHistory.pop(); // get previous level
  setNavHistory(prevHistory);

  if (lastLevel) setLevel(lastLevel);

  // Clear booth-specific data
  setHourlyData([]);
  setSelectedBooth(null);

  // Reload pieData based on previous level
  if (lastLevel === "district") {
    axios.get(baseUrl + "pie-district/").then(res => setPieData(res.data));
  }
  if (lastLevel === "constituency") {
    // optionally reload constituency data
    // e.g., store last district clicked and refetch
  }
};

  return (
  <section className="container mt-4">
      <div className="table-responsive">
      <h3 className="text-center">🗳 Live Election Dashboard</h3>

      <div style={{ width: '520px', margin: 'auto' }}>
        {/* Back button */}
        {navHistory.length > 0 && (
          <button
            className="btn btn-outline-secondary mb-2"
            onClick={handleBack}
          >
            ← Back
          </button>
        )}
<h4 className="text-center mb-3">
  {level === "district" && "District-wise Voters"}
  {level === "constituency" && "Booth-wise Voters"}
  {selectedBooth && "Hourly Turnout – Booth " + selectedBooth}
</h4>

        {/* Pie Chart */}
        <ResponsiveContainer width={520} height={520}>
          <PieChart>
            <Pie
              data={pieData}
              dataKey="value"
              nameKey="name"
              outerRadius={150}
              onClick={onPieClick}

            >
              {pieData.map((_, i) => (
                <Cell key={i} fill={COLORS[i % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend
              layout="vertical"
              align="right"
              verticalAlign="middle"
              wrapperStyle={{ maxHeight: 350, overflowY: "auto" }}
              onClick={onLegendClick}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {hourlyData.length > 0 && (
        <>
          <h4 className="text-center mt-4">
            Hourly Turnout – Booth {selectedBooth}
          </h4>

          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={hourlyData}>
              <XAxis dataKey="hour" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Bar dataKey="male_voted" fill="#0088FE" />
              <Bar dataKey="female_voted" fill="#FF8042" />
              <Bar dataKey="third_voted" fill="#00C49F" />
            </BarChart>
          </ResponsiveContainer>
        </>
      )}
    </div>
    </section>
  );
}

export default LiveDashboard;
